import { LocaleEnum, Tooltip, localeLabels, localeNames } from '@systemeio/ui'
import React from 'react'
import { twMerge } from 'tailwind-merge'
import { ChevronDownIcon } from '@systemeio/ui/icons'

export interface LanguageSwitcherProps {
  selectedLanguage: LocaleEnum
  changeLanguage: (locale: LocaleEnum) => void
  listOfLanguages?: LocaleEnum[]
  isFetching?: boolean
  buttonClassName?: string
  menuClassName?: string
  labelClassName?: string
  wrapperClassName?: string
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  selectedLanguage,
  changeLanguage,
  listOfLanguages = Object.values(LocaleEnum),
  isFetching,
  buttonClassName,
  labelClassName,
  wrapperClassName,
}) => {
  return (
    <Tooltip
      anchor={{
        gap: -5,
      }}
      wrapperClassName={wrapperClassName}
      stayOnHover={true}
      className={'h-full'}
      popoverClassName={'p-0 shadow-lg rounded-lg'}
      label={
        <div
          className={twMerge(
            'customScroll bg-background-secondary z-50 max-h-[400px] overflow-hidden overflow-y-auto rounded-lg shadow-lg',
            isFetching && 'pointer-events-none',
          )}
        >
          <ul className={'text-text-tertiary flex flex-col whitespace-nowrap py-4 text-sm'}>
            {listOfLanguages.map(language => (
              <li key={language}>
                <button
                  disabled={language === selectedLanguage}
                  className={`hover:text-brand-primary focus-visible:text-brand-primary main-transition-colors text-start w-full px-7 py-1 focus:outline-hidden ${
                    language === selectedLanguage ? 'text-brand-primary' : 'text-text-tertiary'
                  }`}
                  data-test={`language-switcher-option-button-${language}`}
                >
                  <p onClick={() => changeLanguage(language)}>{localeNames[language]}</p>
                </button>
              </li>
            ))}
          </ul>
        </div>
      }
    >
      <button
        disabled={isFetching}
        className={twMerge('flex items-center gap-2 text-sm font-normal', buttonClassName)}
        data-test="language-switcher-button"
      >
        <div className={twMerge('text-start flex-1 capitalize', labelClassName)}>
          {selectedLanguage && localeLabels[selectedLanguage]}
        </div>
        <ChevronDownIcon />
      </button>
    </Tooltip>
  )
}
